/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PianificazioneResDto } from '../../models/pianificazione-res-dto';

export interface PianificazioniControllerCreatePianificazione$Params {
  body: PianificazioneResDto;
}

export function pianificazioniControllerCreatePianificazione(
  http: HttpClient,
  rootUrl: string,
  params: PianificazioniControllerCreatePianificazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PianificazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    pianificazioniControllerCreatePianificazione.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PianificazioneResDto>;
      }),
    );
}

pianificazioniControllerCreatePianificazione.PATH = '/admin/pianificazioni';
